
import Vue, { PropType } from 'vue';
import { CustomComponentType } from '@sageworks/dynamic-forms';
import IconSelectorButton from '../icon-selector-button/icon-selector-button.vue';
import { PriorEntriesDisplay } from '../../../models/PriorEntriesDisplay';

export default Vue.extend({
	name: 'ExistingEntrySelector',
	components: {
		IconSelectorButton
	},
	props: {
		componentType: {
			type: String as PropType<CustomComponentType>,
			required: true
		},
		priorLoanEntries: {
			type: Array as PropType<PriorEntriesDisplay[]>,
			required: true,
			default: () => []
		},
		componentId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			entriesAdded: []
		};
	},
	computed: {
		displayEntriesAdded(): string {
			const maxDisplayCount = 4;
			if (this.entriesAdded.length > maxDisplayCount) {
				const displayedEntities = this.entriesAdded.slice(0, maxDisplayCount).join('; ');
				const remainingCount = this.entriesAdded.length - maxDisplayCount;
				return `${displayedEntities} (+${remainingCount} more)`;
			}
			return this.entriesAdded.join('; ');
		},
		ListTypeLabel(): string {
			return this.componentType === CustomComponentType.collateralInfo ? 'Collateral' : 'Applicant';
		}
	},

	methods: {
		useEntry(id: number) {
			const foundEntry = this.priorLoanEntries.find((entry: { id: number }) => entry.id === id);
			if (foundEntry) {
				this.$emit('entry-selected', { id: id, borrowerType: foundEntry.type.toLowerCase() });
				this.entriesAdded.push(foundEntry.name);
			}
		},
		closeModal() {
			this.$bvModal.hide(`select-previous-entries-${this.componentType}-${this.componentId}`);
		},
		clearEntriesAdded() {
			this.entriesAdded = [];
		}
	}
});
